/**
 * Auto-generated file. Do not edit manually.
 * Source: scripts/publish-gallery-showcase.ts
 */

const _generatedGallerySummary = {
  generatedAt: "2026-03-04T10:08:47.261Z",
  sourceMode: "local",
  totalItems: 300,
  sectionCounts: {
    plain: 30,
    styles: 30,
    colors: 30,
    "image-overlay": 30,
    "animation-overlay": 30,
    "blend-modes": 30,
    "color-modes": 30,
    encoding: 30,
    "power-combos": 30,
    "qr-art": 30,
  },
} as const;

export const generatedGallerySections = [
  {
    id: "plain",
    title: "Plain QR Codes",
    description: "Baseline QR variants focused on clean geometry and predictable scan behavior.",
    icon: "QrCode",
    items: [
      {
        id: "nooverlay__bg-faf5ff",
        title: "Plain Square · V3 · Mask Auto · Square",
        description: "v3 EC H · variant Mask Auto · Square",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "faf5ff",
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__filler-static-1",
        title: "Plain Rounded · V3 · Mask Auto · Rounded",
        description: "v3 EC H · Rounded modules · variant Mask Auto · Rounded",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "f0fdf4",
          border: 2,
          cGuard: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "circle",
          fg: "1a365d",
          finder: "rounded",
          format: "png",
          frame: "rounded_frame",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          jitter: 0,
          minContrast: 4.5,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__power-19",
        title: "Plain Dots · V3 · Mask Auto · Dots",
        description: "v3 EC Q · Dots modules · variant Mask Auto · Dots",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "Q",
          eyeInner: "circle",
          eyeOuter: "circle",
          finder: "circle",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__style-x-gap-connected-negative_space",
        title: "Plain Connected · V4 · Mask Auto · Connected",
        description: "v4 EC H · Connected modules · variant Mask Auto · Connected",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "negative_space",
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "connected",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__style-diamond",
        title: "Plain Diamond · V3 · Mask 3 · Diamond",
        description: "v3 EC H · Diamond modules · variant Mask 3 · Diamond",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          mask: 3,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__finder-circle",
        title: "Plain Square · V3 · Mask 6 · Square",
        description: "v3 EC H · variant Mask 6 · Square",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          mask: 6,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__power-0",
        title: "Plain Rounded · V3 · Mask Auto · Rounded · Power 0",
        description: "v3 EC H · Rounded modules · variant Mask Auto · Rounded",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__gapMode-negative_space",
        title: "Plain Square · V3 · Mask 1 · Square",
        description: "v3 EC H · variant Mask 1 · Square",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "negative_space",
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          mask: 1,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__wm-x-style-connected-text",
        title: "Plain Connected · V5 · Mask Auto · Connected",
        description: "v5 EC H · Connected modules · variant Mask Auto · Connected",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "connected",
          timing: "match_module",
          v: 5,
          w: 294,
          wmEn: 1,
          wmKind: "text",
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__style-x-frame-diamond-sticker",
        title: "Plain Diamond · V3 · Mask Auto · Diamond",
        description: "v3 EC H · Diamond modules · variant Mask Auto · Diamond",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__style-dots",
        title: "Plain Dots · V3 · Mask 2 · Dots",
        description: "v3 EC H · Dots modules · variant Mask 2 · Dots",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          mask: 2,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__power-14",
        title: "Plain Rounded · V3 · Mask Auto · Rounded · Power 14",
        description: "v3 EC H · Rounded modules · variant Mask Auto · Rounded",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          crisp: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "stroke",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__style-connected",
        title: "Plain Connected · V3 · Mask 4 · Connected",
        description: "v3 EC H · Connected modules · variant Mask 4 · Connected",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          mask: 4,
          modulePx: 6,
          radius: 25,
          style: "connected",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__wmOpacity-30",
        title: "Plain Square · V7 · Mask Auto · Square",
        description: "v7 EC H · variant Mask Auto · Square",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 7,
          w: 294,
          wmEn: 1,
          wmKind: "text",
          wmOpacity: 30,
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__grad-conic",
        title: "Plain Square · V3 · Mask 7 · Square",
        description: "v3 EC H · variant Mask 7 · Square",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          jitter: 0,
          mask: 7,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__grad-linear",
        title: "Plain Square · V3 · Mask 5 · Square",
        description: "v3 EC H · variant Mask 5 · Square",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          jitter: 0,
          mask: 5,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__gradStops-0ea5e9,0,6366f1,1",
        title: "Plain Square · V3 · Mask 0 · Square",
        description: "v3 EC H · variant Mask 0 · Square",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          jitter: 0,
          mask: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__style-x-gap-diamond-inset",
        title: "Plain Diamond · V4 · Mask Auto · Diamond",
        description: "v4 EC H · Diamond modules · variant Mask Auto · Diamond",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__power-12",
        title: "Plain Rounded · V3 · Mask Auto · Rounded · Power 12",
        description: "v3 EC H · Rounded modules · variant Mask Auto · Rounded",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__style-x-gap-dots-inset",
        title: "Plain Dots · V4 · Mask Auto · Dots",
        description: "v4 EC H · Dots modules · variant Mask Auto · Dots",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__power-1",
        title: "Plain Dots · V3 · Mask Auto · Dots · Power 1 2",
        description: "v3 EC H · Dots modules · variant Mask Auto · Dots",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__style-x-gap-diamond-negative_space",
        title: "Plain Diamond · V4 · Mask Auto · Diamond · Style X",
        description: "v4 EC H · Diamond modules · variant Mask Auto · Diamond",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "negative_space",
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__style-x-frame-connected-rounded_frame",
        title: "Plain Connected · V3 · Mask Auto · Connected",
        description: "v3 EC H · Connected modules · variant Mask Auto · Connected",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frame: "rounded_frame",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "connected",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__style-x-frame-connected-sticker",
        title: "Plain Connected · V3 · Mask Auto · Connected · Style X",
        description: "v3 EC H · Connected modules · variant Mask Auto · Connected",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "connected",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__wm-x-style-diamond-text",
        title: "Plain Diamond · V5 · Mask Auto · Diamond",
        description: "v5 EC H · Diamond modules · variant Mask Auto · Diamond",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 5,
          w: 294,
          wmEn: 1,
          wmKind: "text",
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__style-rounded",
        title: "Plain Rounded · V3 · Mask 1 · Rounded",
        description: "v3 EC H · Rounded modules · variant Mask 1 · Rounded",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          mask: 1,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__grad-radial",
        title: "Plain Square · V3 · Mask 6 · Square · Grad Radial",
        description: "v3 EC H · variant Mask 6 · Square",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          jitter: 0,
          mask: 6,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__gradStops-059669,0,0284c7,1",
        title: "Plain Square · V3 · Mask 3 · Square",
        description: "v3 EC H · variant Mask 3 · Square",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          jitter: 0,
          mask: 3,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__style-x-gap-dots-negative_space",
        title: "Plain Dots · V4 · Mask Auto · Dots · Style X",
        description: "v4 EC H · Dots modules · variant Mask Auto · Dots",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "negative_space",
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__gradStops-7c3aed,0,ec4899,0.5,f59e0b,1",
        title: "Plain Square · V3 · Mask 2 · Square",
        description: "v3 EC H · variant Mask 2 · Square",
        category: "plain",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          jitter: 0,
          mask: 2,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
    ],
  },
  {
    id: "styles",
    title: "Module & Finder Styles",
    description: "Shape and structure exploration across modules, eyes, frames, and spacing modes.",
    icon: "Shapes",
    items: [
      {
        id: "nooverlay__anim-flag-drift-animSeed",
        title: "Dots Modules · Rounded Finder · Dots · Rounded",
        description: "v3 EC H · anim Drift · variant Dots · Rounded",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 123,
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__filler-static-16",
        title: "Rounded Modules · Circle Finder · Rounded · Circle",
        description: "v3 EC H · variant Rounded · Circle",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "f0fdf4",
          border: 1,
          cGuard: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "rounded",
          fg: "1a365d",
          finder: "circle",
          format: "png",
          frame: "rounded_frame",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          jitter: 0,
          minContrast: 4.5,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__eyeO-x-eyeI-circle-circle",
        title: "Square Modules · Square Finder · Square · Circle",
        description: "v3 EC H · variant Square · Circle",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "circle",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__power-18",
        title: "Diamond Modules · Circle Finder · Diamond · Circle",
        description: "v3 EC H · variant Diamond · Circle",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          fg: "166534",
          finder: "circle",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gapMode: "negative_space",
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__reverse",
        title: "Connected Modules · Rounded Finder · Connected · Rounded",
        description: "v3 EC H · anim Wave · variant Connected · Rounded",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gapMode: "stroke",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          jitter: 0,
          mask: 0,
          modulePx: 6,
          radius: 25,
          reverse: 1,
          style: "connected",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__visual-motion-8",
        title: "Rounded Modules · Rounded Finder · Rounded · Sticker",
        description: "v4 EC H · anim Pulse · variant Rounded · Sticker",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          bounce: 1,
          data: "https://anqr.link",
          dotRot: 0,
          easing: "bounce",
          ec: "H",
          finder: "rounded",
          format: "gif",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          reverse: 1,
          style: "rounded",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__bonus-full-featured",
        title: "Rounded Modules · Rounded Finder · Rounded · Tag",
        description: "v3 EC H · variant Rounded · Tag",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "faf5ff",
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "rounded",
          fg: "1a365d",
          finder: "rounded",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "6366f1,0,ec4899,0.5,f59e0b,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__visual-motion-10",
        title: "Dots Modules · Circle Finder · Dots · Circle",
        description: "v4 EC H · anim Drift · variant Dots · Circle",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 999,
          animSpeed: 100,
          colorCycle: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "circle",
          finder: "circle",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__eyeO-x-eyeI-circle-rounded",
        title: "Square Modules · Square Finder · Square · Circle · Eyeo X",
        description: "v3 EC H · variant Square · Circle",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "circle",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__anim-x-style-pulse-diamond",
        title: "Diamond Modules · Square Finder · Diamond · Square",
        description: "v3 EC H · anim Pulse · variant Diamond · Square",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__power-16",
        title: "Connected Modules · Square Finder · Connected · Square",
        description: "v3 EC H · variant Connected · Square",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "fff5e6",
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeScale: 105,
          fg: "c41e3a",
          format: "png",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "connected",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__animPattern-pulse",
        title: "Rounded Modules · Circle Finder · Rounded · Circle · Animpattern Pulse 2",
        description: "v3 EC H · anim Pulse · variant Rounded · Circle",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gapMode: "negative_space",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          jitter: 0,
          mask: 0,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__power-13",
        title: "Diamond Modules · Rounded Finder · Diamond · Rounded",
        description: "v3 EC H · variant Diamond · Rounded",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "rounded",
          finder: "rounded",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__animPattern-wave",
        title: "Dots Modules · Rounded Finder · Dots · Rounded · Animpattern Wave 2",
        description: "v3 EC H · anim Wave · variant Dots · Rounded",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          jitter: 0,
          mask: 1,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__power-5",
        title: "Dots Modules · Circle Finder · Dots · Circle · Power 5 2",
        description: "v3 EC H · variant Dots · Circle",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeOuter: "circle",
          finder: "circle",
          format: "png",
          frame: "rounded_frame",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__visual-motion-5",
        title: "Rounded Modules · Circle Finder · Rounded · Circle · Visual Motion 2",
        description: "v4 EC H · anim Drift · variant Rounded · Circle",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 123,
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "gif",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          interp: "morph",
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__gapMode-stroke",
        title: "Square Modules · Square Finder · Square · Stroke",
        description: "v3 EC H · variant Square · Stroke",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "stroke",
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          mask: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__visual-motion-4",
        title: "Connected Modules · Square Finder · Connected · Square · Visual Motion 2",
        description: "v4 EC H · anim Scanline · variant Connected · Square",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          bg: "ffffff",
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          fg: "1a365d",
          finder: "square",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          interp: "crossfade",
          jitter: 0,
          modulePx: 6,
          radius: 25,
          reverse: 1,
          style: "connected",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__eyeO-x-eyeI-rounded-circle",
        title: "Square Modules · Square Finder · Square · Rounded",
        description: "v3 EC H · variant Square · Rounded",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "rounded",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__animPattern-drift",
        title: "Rounded Modules · Circle Finder · Rounded · Circle · Animpattern Drift 2",
        description: "v3 EC H · anim Drift · variant Rounded · Circle",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          jitter: 0,
          mask: 3,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__visual-static-3",
        title: "Diamond Modules · Rounded Finder · Diamond · Rounded · Visual Static 2",
        description: "v4 EC H · variant Diamond · Rounded",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          border: 2,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "circle",
          finder: "rounded",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__visual-motion-9",
        title: "Connected Modules · Square Finder · Connected · Square · Visual Motion",
        description: "v4 EC H · anim Scanline · variant Connected · Square",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "square",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          interp: "morph",
          jitter: 0,
          modColor: "by_cluster",
          modulePx: 6,
          palette: "00b894,00cec9,0984e3,6c5ce7,e17055",
          paletteMode: "diagonal",
          radius: 25,
          style: "connected",
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__visual-static-6",
        title: "Dots Modules · Circle Finder · Dots · Circle · Visual Static 2",
        description: "v4 EC H · variant Dots · Circle",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          cGuard: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "negative_space",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          jitter: 0,
          minContrast: 4.5,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__anim-flag-scanline-colorCycle",
        title: "Diamond Modules · Rounded Finder · Diamond · Rounded · Anim Flag 2",
        description: "v3 EC H · anim Scanline · variant Diamond · Rounded",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          colorCycle: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__eyeO-x-eyeI-rounded-rounded",
        title: "Square Modules · Square Finder · Square · Rounded · Eyeo X",
        description: "v3 EC H · variant Square · Rounded",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "rounded",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__anim-flag-pulse-colorCycle",
        title: "Dots Modules · Rounded Finder · Dots · Rounded · Anim Flag 2",
        description: "v3 EC H · anim Pulse · variant Dots · Rounded",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          colorCycle: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__power-3",
        title: "Connected Modules · Square Finder · Connected · Square · Power 3",
        description: "v3 EC H · variant Connected · Square",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "fff5e6",
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          fg: "1a365d",
          format: "png",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "connected",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__anim-flag-wave-reverse",
        title: "Diamond Modules · Circle Finder · Diamond · Circle · Anim Flag 2",
        description: "v3 EC H · anim Wave · variant Diamond · Circle",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          reverse: 1,
          style: "diamond",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__frame-x-grad-rounded_frame-conic",
        title: "Square Modules · Square Finder · Square · Rounded Frame",
        description: "v3 EC H · variant Square · Rounded Frame",
        category: "styles",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frame: "rounded_frame",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__anim-flag-pulse-reverse",
        title: "Rounded Modules · Circle Finder · Rounded · Circle · Anim Flag",
        description: "v3 EC H · anim Pulse · variant Rounded · Circle",
        category: "styles",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          reverse: 1,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
    ],
  },
  {
    id: "colors",
    title: "Colors & Themes",
    description: "Foreground/background palettes, gradients, and module color strategies.",
    icon: "Palette",
    items: [
      {
        id: "nooverlay__anim-flag-scanline-reverse",
        title: "Linear · #000000 · Linear",
        description: "v3 EC H · anim Scanline · Dots modules · variant Linear",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          reverse: 1,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__fg-x-bg-000000-f0fdf4",
        title: "Theme · #000000 · Theme · Fg 000000",
        description: "v3 EC H · variant Theme · Fg 000000",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "f0fdf4",
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          fg: "000000",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__filler-static-12",
        title: "Conic · #c41e3a · Conic · Fg C41e3a",
        description: "v3 EC H · Rounded modules · variant Conic · Fg C41e3a",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "faf5ff",
          border: 1,
          cGuard: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "rounded",
          fg: "c41e3a",
          finder: "rounded",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          jitter: 0,
          minContrast: 4.5,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__filler-static-23",
        title: "Radial · #166534 · Radial · Fg 166534",
        description: "v3 EC H · Rounded modules · variant Radial · Fg 166534",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "fef3c7",
          border: 2,
          cGuard: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "circle",
          fg: "166534",
          finder: "circle",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          jitter: 0,
          minContrast: 4.5,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__filler-static-14",
        title: "Conic · #6b21a8 · Conic · Fg 6b21a8",
        description: "v3 EC H · Rounded modules · variant Conic · Fg 6b21a8",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "ffffff",
          border: 1,
          cGuard: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "rounded",
          fg: "6b21a8",
          finder: "rounded",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          jitter: 0,
          minContrast: 4.5,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__modC-x-pal-by_brightness-00b894,00cec9,0984e3,6c5ce7,e17055",
        title: "Position · #000000 · Position",
        description: "v3 EC H · variant Position",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modColor: "by_brightness",
          modulePx: 6,
          palette: "00b894,00cec9,0984e3,6c5ce7,e17055",
          paletteMode: "position",
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__power-8",
        title: "Radial · #000000 · Radial",
        description: "v3 EC H · Dots modules · variant Radial",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modColor: "by_position",
          modulePx: 6,
          palette: "1e3a8a,2563eb,059669,d97706,dc2626",
          paletteMode: "radial",
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__power-9",
        title: "Brightness · #000000 · Brightness",
        description: "v3 EC H · Connected modules · variant Brightness",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modColor: "by_cluster",
          modulePx: 6,
          palette: "6c5ce7,a29bfe,fd79a8,fab1a0,ffeaa7",
          paletteMode: "brightness",
          radius: 25,
          style: "connected",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__fg-x-bg-1a365d-fff5e6",
        title: "Theme · #1a365d · Theme · Fg 1a365d",
        description: "v3 EC H · variant Theme · Fg 1a365d",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "fff5e6",
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          fg: "1a365d",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__anim-flag-wave-colorCycle",
        title: "Radial · #000000 · Radial · Anim Flag 2",
        description: "v3 EC H · anim Wave · Rounded modules · variant Radial",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          colorCycle: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__power-7",
        title: "Diagonal · #000000 · Diagonal",
        description: "v3 EC H · Rounded modules · variant Diagonal",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modColor: "by_brightness",
          modulePx: 6,
          palette: "ff6b6b,feca57,48dbfb,ff9ff3,54a0ff",
          paletteMode: "diagonal",
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__paletteMode-column",
        title: "Column · #000000 · Column",
        description: "v3 EC H · variant Column",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          palette: "ff6b6b,feca57,48dbfb,ff9ff3,54a0ff",
          paletteMode: "column",
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__paletteMode-row",
        title: "Row · #000000 · Row",
        description: "v3 EC H · variant Row",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          palette: "ff6b6b,feca57,48dbfb,ff9ff3,54a0ff",
          paletteMode: "row",
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__anim-flag-shimmer-colorCycle",
        title: "Linear · #000000 · Linear · Anim Flag 2",
        description: "v3 EC H · anim Shimmer · Rounded modules · variant Linear",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          colorCycle: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__animSeed-123",
        title: "Radial · #000000 · Radial · Animseed 123 2",
        description: "v3 EC H · anim Drift · Dots modules · variant Radial",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 123,
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          jitter: 0,
          mask: 3,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__animSeed-42",
        title: "Linear · #000000 · Linear · Animseed 42 2",
        description: "v3 EC H · anim Drift · Rounded modules · variant Linear",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 42,
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          jitter: 0,
          mask: 2,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__visual-motion-3",
        title: "Conic · #000000 · Conic",
        description: "v4 EC H · anim Pulse · Diamond modules · variant Conic",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          bounce: 1,
          data: "https://anqr.link",
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          finder: "rounded",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__visual-target-stack-4",
        title: "Radial · #000000 · Radial · Visual Target 2",
        description: "v4 EC H · anim Scanline · stack Wave · Rounded modules · variant Radial",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animPattern2: "wave",
          animSpeed: 100,
          animTarget: "modules",
          animTarget2: "result",
          animWaveAxis2: "x",
          data: "https://anqr.link",
          dotRot: 0,
          easing: "ease_in",
          ec: "H",
          finder: "circle",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          reverse: 1,
          style: "rounded",
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__anim-x-grad-pulse-conic",
        title: "Conic · #000000 · Conic · Anim X 2",
        description: "v3 EC H · anim Pulse · variant Conic",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__interp-morph",
        title: "Linear · #000000 · Linear · Interp Morph 2",
        description: "v3 EC H · anim Wave · Dots modules · variant Linear",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          interp: "morph",
          jitter: 0,
          mask: 5,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__colorCycle",
        title: "Radial · #000000 · Radial · Colorcycle 2",
        description: "v3 EC H · anim Shimmer · Dots modules · variant Radial",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          colorCycle: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          jitter: 0,
          mask: 1,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__visual-motion-6",
        title: "Conic · #000000 · Conic · Visual Motion 2",
        description: "v4 EC H · anim Wave · Dots modules · variant Conic",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          interp: "crossfade",
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "dots",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__visual-static-1",
        title: "Linear · #1a365d · Linear · Fg 1a365d",
        description: "v4 EC H · Rounded modules · variant Linear · Fg 1a365d",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "faf5ff",
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          fg: "1a365d",
          finder: "rounded",
          format: "png",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__visual-motion-2",
        title: "Radial · #000000 · Radial · Visual Motion 2",
        description: "v4 EC H · anim Shimmer · Dots modules · variant Radial",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          colorCycle: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          interp: "crossfade",
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "dots",
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__visual-static-2",
        title: "Radial · #c41e3a · Radial · Fg C41e3a",
        description: "v4 EC H · Dots modules · variant Radial · Fg C41e3a",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "fff5e6",
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          fg: "c41e3a",
          finder: "circle",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__visual-motion-7",
        title: "Radial · #000000 · Radial · Visual Motion 3",
        description: "v4 EC H · anim Shimmer · Diamond modules · variant Radial",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          colorCycle: 1,
          data: "https://anqr.link",
          dotRot: 0,
          easing: "ease_in",
          ec: "H",
          finder: "rounded",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 4,
          w: 294,
          wmEn: 1,
          wmKind: "text",
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__modC-x-pal-by_position-1a1a2e,16213e,0f3460,e94560,533483",
        title: "Position · #000000 · Position · Modc X",
        description: "v3 EC H · variant Position",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modColor: "by_position",
          modulePx: 6,
          palette: "1a1a2e,16213e,0f3460,e94560,533483",
          paletteMode: "position",
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__anim-x-grad-pulse-linear",
        title: "Linear · #000000 · Linear · Anim X 2",
        description: "v3 EC H · anim Pulse · variant Linear",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__fg-x-bg-000000-fef3c7",
        title: "Theme · #000000 · Theme · Fg 000000 · Fg X",
        description: "v3 EC H · variant Theme · Fg 000000",
        category: "colors",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "fef3c7",
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          fg: "000000",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__anim-x-grad-scanline-conic",
        title: "Conic · #000000 · Conic · Anim X 3",
        description: "v3 EC H · anim Scanline · variant Conic",
        category: "colors",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
    ],
  },
  {
    id: "image-overlay",
    title: "Image Overlays",
    description:
      "Static overlay rendering with blend modes, image transforms, and placement controls.",
    icon: "Image",
    items: [
      {
        id: "overlay__colorMode-grayscale",
        title: "Blend · Logo · Blend · Error Diffusion",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "grayscale",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__ditherKind-blue_noise_threshold",
        title: "Dithered · Tsunami · Dithered · Blue Noise Threshold",
        description:
          "v3 EC H · mode Dithered · dither Blue Noise Threshold · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "blue_noise_threshold",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-x-fm-mosaic-contain",
        title: "Mosaic · Logo · Mosaic · Error Diffusion",
        description:
          "v3 EC H · mode Mosaic · dither Error Diffusion · fit Contain · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "contain",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "mosaic",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-dither-test",
        title: "Dither · Test · Dither · Error Diffusion",
        description:
          "v3 EC H · mode Dither · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dither",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-halftone-santa",
        title: "Halftone · Santa · Halftone · Error Diffusion",
        description:
          "v3 EC H · mode Halftone · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 3,
          matrix: "bayer4",
          mode: "halftone",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__ditherKind-screened_blue_noise",
        title: "Dithered · Logo · Dithered · Screened Blue Noise",
        description:
          "v3 EC H · mode Dithered · dither Screened Blue Noise · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "screened_blue_noise",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-center-tsunami",
        title: "Center · Tsunami · Center · Error Diffusion",
        description:
          "v3 EC H · mode Center · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 0,
          matrix: "bayer4",
          mode: "center",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-extreme-test",
        title: "Extreme · Test · Extreme · Error Diffusion",
        description:
          "v3 EC H · mode Extreme · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "extreme",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-pixelate-santa",
        title: "Pixelate · Santa · Pixelate · Error Diffusion",
        description:
          "v3 EC H · mode Pixelate · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "pixelate",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-x-fm-dithered-stretch",
        title: "Dithered · Logo · Dithered · Error Diffusion",
        description:
          "v3 EC H · mode Dithered · dither Error Diffusion · fit Stretch · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "stretch",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-x-dk-dithered-blue_noise",
        title: "Dithered · Logo · Dithered · Blue Noise",
        description:
          "v3 EC H · mode Dithered · dither Blue Noise · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "blue_noise",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-duotone-tsunami",
        title: "Duotone · Tsunami · Duotone · Error Diffusion",
        description:
          "v3 EC H · mode Duotone · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "duotone",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-outline-test",
        title: "Outline · Test · Outline · Error Diffusion",
        description:
          "v3 EC H · mode Outline · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "outline",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-wave-santa",
        title: "Wave · Santa · Wave · Error Diffusion",
        description:
          "v3 EC H · mode Wave · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-x-dk-dithered-triangular_noise",
        title: "Dithered · Logo · Dithered · Triangular Noise",
        description:
          "v3 EC H · mode Dithered · dither Triangular Noise · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "triangular_noise",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-halftone-dithered-tsunami",
        title: "Halftone Dithered · Tsunami · Halftone Dithered · Error Diffusion",
        description:
          "v3 EC H · mode Halftone Dithered · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 4,
          matrix: "bayer4",
          mode: "halftone-dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-subpixel-size-test",
        title: "Subpixel Size · Test · Subpixel Size · Error Diffusion",
        description:
          "v3 EC H · mode Subpixel Size · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel-size",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-subpixel-tsunami",
        title: "Subpixel · Tsunami · Subpixel · Error Diffusion",
        description:
          "v3 EC H · mode Subpixel · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-gapfill-logo",
        title: "Gapfill · Logo · Gapfill · Error Diffusion",
        description:
          "v3 EC H · mode Gapfill · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 0,
          matrix: "bayer4",
          mode: "gapfill",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__filter-edge",
        title: "Blend · Santa · Blend · Error Diffusion",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          edge: "sobel",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__filter-x-mode-mosaic-edge",
        title: "Mosaic · Test · Mosaic · Error Diffusion",
        description:
          "v3 EC H · mode Mosaic · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          edge: "sobel",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "mosaic",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__htDot-circle",
        title: "Halftone · Tsunami · Halftone · Error Diffusion",
        description:
          "v3 EC H · mode Halftone · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          htDot: "circle",
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "halftone",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-wave-test",
        title: "Wave · Test · Wave · Error Diffusion",
        description:
          "v3 EC H · mode Wave · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-dither-tsunami",
        title: "Dither · Tsunami · Dither · Error Diffusion",
        description:
          "v3 EC H · mode Dither · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dither",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__spGridNum-3",
        title: "Subpixel Size · Test · Subpixel Size · Error Diffusion · Spgridnum 3 2",
        description:
          "v5 EC H · mode Subpixel Size · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel-size",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          spGridNum: 3,
          timing: "match_module",
          v: 5,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-center-logo",
        title: "Center · Logo · Center · Error Diffusion",
        description:
          "v3 EC H · mode Center · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 1,
          matrix: "bayer4",
          mode: "center",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-extreme-tsunami",
        title: "Extreme · Tsunami · Extreme · Error Diffusion",
        description:
          "v3 EC H · mode Extreme · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "extreme",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-outline-logo",
        title: "Outline · Logo · Outline · Error Diffusion",
        description:
          "v3 EC H · mode Outline · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "outline",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-pixelate-tsunami",
        title: "Pixelate · Tsunami · Pixelate · Error Diffusion",
        description:
          "v3 EC H · mode Pixelate · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "pixelate",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-subpixel-logo",
        title: "Subpixel · Logo · Subpixel · Error Diffusion",
        description:
          "v3 EC H · mode Subpixel · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "image-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
    ],
  },
  {
    id: "animation-overlay",
    title: "Animated Overlays",
    description: "Overlay motion, stacked animation targets, interpolation, and temporal effects.",
    icon: "Film",
    items: [
      {
        id: "overlay__animHero-king-drift",
        title: "Drift · King GIF · Drift",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Drift · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__target-stack-dance-modules-scanline-plus-result-wave-x",
        title: "Scanline · Dance GIF · Scanline · Wave",
        description:
          "v5 EC H · mode Subpixel · dither Error Diffusion · anim Scanline · stack Wave",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animPattern2: "wave",
          animSpeed: 100,
          animTarget: "modules",
          animTarget2: "result",
          animWaveAxis2: "x",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in",
          ec: "H",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          style: "rounded",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 5,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-dither-dance-screened_blue_noise",
        title: "Shimmer · Dance GIF · Shimmer · Morph",
        description:
          "v3 EC H · mode Dithered · dither Screened Blue Noise · anim Shimmer · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "sierra_2",
          ditherKind: "screened_blue_noise",
          ditherStrength: 60,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__target-stack-king-result-wave-y-plus-modules-shimmer",
        title: "Wave · King GIF · Wave · Shimmer",
        description: "v5 EC H · mode Mosaic · dither Error Diffusion · anim Wave · stack Shimmer",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animPattern2: "shimmer",
          animSpeed: 100,
          animTarget: "result",
          animTarget2: "modules",
          animWaveAxis: "y",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "mosaic",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 5,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-pixelate-anim-dance",
        title: "Animated · Dance GIF · Animated",
        description:
          "v3 EC H · mode Pixelate · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 5,
          matrix: "bayer4",
          mode: "pixelate",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__ov-x-anim-king-wave-pulse",
        title: "Pulse · King GIF · Pulse",
        description: "v4 EC H · mode Wave · dither Error Diffusion · anim Pulse · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__target-stack-king-modules-wave-x-plus-result-wave-y",
        title: "Wave · King GIF · Wave",
        description: "v5 EC H · mode Blend · dither Error Diffusion · anim Wave · stack Wave",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animPattern2: "wave",
          animSpeed: 100,
          animTarget: "modules",
          animTarget2: "result",
          animWaveAxis: "x",
          animWaveAxis2: "y",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 5,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-motion-dance-subpixel-shimmer-reverse",
        title: "Shimmer · Dance GIF · Shimmer · Crossfade",
        description: "v3 EC H · mode Subpixel · dither Error Diffusion · anim Shimmer · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-stack-dance-dither-scanline-adaptive",
        title: "Scanline · Dance GIF · Scanline · Morph",
        description: "v3 EC H · mode Dithered · dither Error Diffusion · anim Scanline · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "sierra_2",
          ditherKind: "error_diffusion",
          ditherStrength: 62,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          tempDither: "blue_noise",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__target-stack-dance-result-wave-y-plus-modules-shimmer",
        title: "Wave · Dance GIF · Wave · Shimmer",
        description: "v5 EC H · mode Mosaic · dither Error Diffusion · anim Wave · stack Shimmer",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animPattern2: "shimmer",
          animSpeed: 100,
          animTarget: "result",
          animTarget2: "modules",
          animWaveAxis: "y",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "mosaic",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 5,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-motion-king-wave-drift-cycle",
        title: "Drift · King GIF · Drift · Hero Motion 2",
        description: "v3 EC H · mode Wave · dither Error Diffusion · anim Drift · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 404,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__animHero-king-pulse",
        title: "Pulse · King GIF · Pulse · Animhero King 2",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Pulse · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-stack-dance-wave-scanline-reverse",
        title: "Scanline · Dance GIF · Scanline · Morph · Hero Stack 2",
        description: "v3 EC H · mode Wave · dither Error Diffusion · anim Scanline · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          bounce: 1,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-motion-king-subpixel-shimmer-reverse",
        title: "Shimmer · King GIF · Shimmer · Crossfade",
        description: "v3 EC H · mode Subpixel · dither Error Diffusion · anim Shimmer · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-motion-king-mosaic-drift-soft",
        title: "Drift · King GIF · Drift · Crossfade",
        description: "v3 EC H · mode Mosaic · dither Error Diffusion · anim Drift · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 87,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "mosaic",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-dither-dance-error_diffusion",
        title: "Wave · Dance GIF · Wave · Morph",
        description: "v3 EC H · mode Dithered · dither Error Diffusion · anim Wave · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          bounce: 1,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "sierra_2",
          ditherKind: "error_diffusion",
          ditherStrength: 60,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "blue_noise",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-stack-dance-dither-pulse-bayer-reverse",
        title: "Pulse · Dance GIF · Pulse",
        description: "v3 EC H · mode Dithered · dither Ordered Bayer · anim Pulse · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSeed: 313,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          bounce: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "atkinson",
          ditherKind: "ordered_bayer",
          ditherStrength: 60,
          dotRot: 0,
          easing: "bounce",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-stack-king-wave-scanline-reverse",
        title: "Scanline · King GIF · Scanline · Morph",
        description: "v3 EC H · mode Wave · dither Error Diffusion · anim Scanline · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          bounce: 1,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__target-stack-king-modules-scanline-plus-result-wave-x",
        title: "Scanline · King GIF · Scanline · Wave",
        description:
          "v5 EC H · mode Subpixel · dither Error Diffusion · anim Scanline · stack Wave",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animPattern2: "wave",
          animSpeed: 100,
          animTarget: "modules",
          animTarget2: "result",
          animWaveAxis2: "x",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in",
          ec: "H",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          style: "rounded",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 5,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__heroFeature-dance-aurora-pulse",
        title: "Pulse · Dance GIF · Pulse · Herofeature Dance 2",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Pulse · Diamond modules",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          bg: "fff5e6",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "circle",
          fg: "4c1d95",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__heroFeature-dance-pop-shimmer",
        title: "Shimmer · Dance GIF · Shimmer · Crossfade · Herofeature Dance 2",
        description: "v3 EC H · mode Mosaic · dither Error Diffusion · anim Shimmer · Dots modules",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          bg: "f0fdf4",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "rounded",
          fg: "1a365d",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "mosaic",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-pixelate-anim-king",
        title: "Animated · King GIF · Animated",
        description:
          "v3 EC H · mode Pixelate · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 4,
          matrix: "bayer4",
          mode: "pixelate",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__heroFeature-dance-retro-drift",
        title: "Drift · Dance GIF · Drift · Morph",
        description: "v3 EC H · mode Wave · dither Error Diffusion · anim Drift · Rounded modules",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 321,
          animSpeed: 100,
          bg: "eef2ff",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in",
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "circle",
          fg: "166534",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__animHero-king-shimmer-crossfade",
        title: "Shimmer · King GIF · Shimmer · Crossfade · Animhero King 2",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Shimmer · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-dither-dance-ordered_bayer",
        title: "Wave · Dance GIF · Wave · Crossfade",
        description: "v3 EC H · mode Dithered · dither Ordered Bayer · anim Wave · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "sierra_lite",
          ditherKind: "ordered_bayer",
          ditherStrength: 60,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          tempDither: "blue_noise",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-motion-king-mosaic-wave-morph",
        title: "Wave · King GIF · Wave · Morph",
        description: "v3 EC H · mode Mosaic · dither Error Diffusion · anim Wave · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          bounce: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "mosaic",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__heroFeature-dance-forest-drift",
        title: "Drift · Dance GIF · Drift · Crossfade",
        description:
          "v3 EC H · mode Subpixel · dither Error Diffusion · anim Drift · Rounded modules",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 777,
          animSpeed: 100,
          bg: "f0fdf4",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "rounded",
          fg: "14532d",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-stack-king-dither-pulse-bayer-reverse",
        title: "Pulse · King GIF · Pulse · Hero Stack 2",
        description: "v3 EC H · mode Dithered · dither Ordered Bayer · anim Pulse · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSeed: 313,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          bounce: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "atkinson",
          ditherKind: "ordered_bayer",
          ditherStrength: 60,
          dotRot: 0,
          easing: "bounce",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-stack-dance-dither-shimmer-blue-noise",
        title: "Shimmer · Dance GIF · Shimmer · Crossfade · Hero Stack 2",
        description:
          "v3 EC H · mode Dithered · dither Screened Blue Noise · anim Shimmer · fit Cover",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "sierra_lite",
          ditherKind: "screened_blue_noise",
          ditherStrength: 58,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__heroFeature-king-retro-drift",
        title: "Drift · King GIF · Drift · Morph",
        description: "v3 EC H · mode Wave · dither Error Diffusion · anim Drift · Rounded modules",
        category: "animation-overlay",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 321,
          animSpeed: 100,
          bg: "eef2ff",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in",
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "circle",
          fg: "166534",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
    ],
  },
  {
    id: "blend-modes",
    title: "Blend Modes",
    description:
      "Preservation behavior and structural safeguards for finder/timing alignment legibility.",
    icon: "Layers",
    items: [
      {
        id: "overlay__hero-motion-dance-blend-drift-crossfade",
        title: "Overlay · Dance GIF · Overlay · Cover",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Drift · fit Cover",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 2026,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "blue_noise",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__logoSize-20",
        title: "Overlay · Tsunami · Overlay · Cover",
        description:
          "v3 EC H · mode Center · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          logoSize: 20,
          matrix: "bayer4",
          mode: "center",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__fit-contain",
        title: "Overlay · Test · Overlay · Contain",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Contain · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "contain",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__logoSize-30",
        title: "Overlay · Logo · Overlay · Cover",
        description:
          "v3 EC H · mode Center · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          logoSize: 30,
          matrix: "bayer4",
          mode: "center",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__fit-stretch",
        title: "Overlay · Santa · Overlay · Stretch",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Stretch · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "stretch",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__logoSize-35",
        title: "Overlay · Test · Overlay · Cover",
        description:
          "v3 EC H · mode Center · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          logoSize: 35,
          matrix: "bayer4",
          mode: "center",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__hero-motion-dance-blend-pulse-easein",
        title: "Overlay · Dance GIF · Overlay · Cover · Hero Motion 2",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Pulse · fit Cover",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSeed: 41,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-motion-dance-blend-wave-crossfade",
        title: "Overlay · Dance GIF · Overlay · Cover · Hero Motion 3",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Wave · fit Cover",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          bounce: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-motion-king-blend-drift-crossfade",
        title: "Overlay · King GIF · Overlay · Cover",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Drift · fit Cover",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 2026,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "blue_noise",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-motion-king-blend-pulse-easein",
        title: "Overlay · King GIF · Overlay · Cover · Hero Motion 2",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Pulse · fit Cover",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSeed: 41,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__hero-motion-king-blend-wave-crossfade",
        title: "Overlay · King GIF · Overlay · Cover · Hero Motion 3",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Wave · fit Cover",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          bounce: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-x-fm-blend-contain",
        title: "Overlay · Logo · Overlay · Contain",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Contain · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "contain",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__hero-stack-dance-blend-drift-softlight",
        title: "Overlay · Dance GIF · Overlay · Cover · Hero Stack",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Drift · fit Cover",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 512,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmBlend: "soft-light",
          wmEn: 1,
          wmKind: "text",
          wmOpacity: 46,
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: true,
      },
      {
        id: "overlay__filter-x-mode-blend-edge",
        title: "Overlay · Test · Overlay · Cover · Filter X 2",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          edge: "sobel",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__hero-stack-dance-blend-shimmer-reverse",
        title: "Overlay · Dance GIF · Overlay · Cover · Hero Stack 2",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Shimmer · fit Cover",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSeed: 606,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__flipX",
        title: "Overlay · Tsunami · Overlay · Cover · Flipx 2",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          flipX: 1,
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__hero-stack-dance-blend-wave-morph-softlight",
        title: "Overlay · Dance GIF · Overlay · Cover · Hero Stack · Hero Stack 2",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Wave · fit Cover",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmBlend: "soft-light",
          wmEn: 1,
          wmKind: "text",
          wmOpacity: 42,
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: true,
      },
      {
        id: "overlay__flipY",
        title: "Overlay · Santa · Overlay · Cover",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          flipY: 1,
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__hero-stack-king-blend-drift-softlight",
        title: "Overlay · King GIF · Overlay · Cover · Hero Stack",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Drift · fit Cover",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 512,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmBlend: "soft-light",
          wmEn: 1,
          wmKind: "text",
          wmOpacity: 46,
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-blend-logo",
        title: "Overlay · Logo · Overlay · Cover · Mode Blend 2",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 5,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__hero-stack-king-blend-shimmer-reverse",
        title: "Overlay · King GIF · Overlay · Cover · Hero Stack 2",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Shimmer · fit Cover",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSeed: 606,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-blend-santa",
        title: "Overlay · Santa · Overlay · Cover · Mode Blend",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 7,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__hero-stack-king-blend-wave-morph-softlight",
        title: "Overlay · King GIF · Overlay · Cover · Hero Stack · Hero Stack 2",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Wave · fit Cover",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmBlend: "soft-light",
          wmEn: 1,
          wmKind: "text",
          wmOpacity: 42,
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-blend-test",
        title: "Overlay · Test · Overlay · Cover · Mode Blend",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 6,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-blend-anim-dance",
        title: "Overlay · Dance GIF · Overlay · Cover · Mode Blend 2",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 3,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-blend-tsunami",
        title: "Overlay · Tsunami · Overlay · Cover · Mode Blend",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 4,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-blend-anim-king",
        title: "Overlay · King GIF · Overlay · Cover · Mode Blend 2",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 2,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-x-cm-blend-bw",
        title: "Overlay · Tsunami · Overlay · Cover · Mode X",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "bw",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-x-cm-blend-grayscale",
        title: "Overlay · Tsunami · Overlay · Cover · Mode X · Mode X 2",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "grayscale",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-x-grad-blend-conic",
        title: "Overlay · Tsunami · Overlay · Cover · Mode X · Mode X 3",
        description:
          "v3 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "blend-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
    ],
  },
  {
    id: "color-modes",
    title: "Color Processing",
    description:
      "Dither families, diffusion kernels, grayscale/BW outputs, and tonal processing variants.",
    icon: "Contrast",
    items: [
      {
        id: "overlay__animHero-dance-wave-morph",
        title: "Error Diffusion · Dance GIF · Error Diffusion · 50",
        description: "v3 EC H · mode Wave · dither Error Diffusion · anim Wave · fit Cover",
        category: "color-modes",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__filler-0",
        title: "Grayscale · King GIF · Grayscale · Blend",
        description: "v3 EC H · mode Blend · anim Wave · Square modules · fit Stretch",
        category: "color-modes",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSeed: 999,
          animSpeed: 100,
          bg: "f0fdf4",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          border: 0,
          bounce: 1,
          colorDither: "none",
          colorMode: "grayscale",
          data: "https://anqr.link",
          dotRot: 0,
          easing: "ease_in",
          ec: "H",
          fg: "000000",
          finder: "square",
          finderDither: 65,
          fit: "stretch",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          palette: "ff6b6b,feca57,48dbfb,ff9ff3,54a0ff",
          paletteMode: "diagonal",
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "square",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__ditherKind-adaptive_threshold",
        title: "Adaptive Threshold · Tsunami · Adaptive Threshold · 50",
        description:
          "v3 EC H · mode Dithered · dither Adaptive Threshold · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "adaptive_threshold",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-x-cm-subpixel-bw",
        title: "Error Diffusion · Tsunami · Error Diffusion · 50",
        description:
          "v3 EC H · mode Subpixel · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "bw",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__hero-dither-dance-blue_noise_threshold",
        title: "Blue Noise Threshold · Dance GIF · Blue Noise Threshold · 60",
        description:
          "v3 EC H · mode Dithered · dither Blue Noise Threshold · anim Shimmer · fit Cover",
        category: "color-modes",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "sierra_2",
          ditherKind: "blue_noise_threshold",
          ditherStrength: 60,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__ditherKind-blue_noise",
        title: "Blue Noise · Test · Blue Noise · 50",
        description:
          "v3 EC H · mode Dithered · dither Blue Noise · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "blue_noise",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__hero-stack-dance-dither-drift-sierra2",
        title: "Screened Blue Noise · Dance GIF · Screened Blue Noise · 68",
        description:
          "v3 EC H · mode Dithered · dither Screened Blue Noise · anim Drift · fit Cover",
        category: "color-modes",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 121,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "sierra_2",
          ditherKind: "screened_blue_noise",
          ditherStrength: 68,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__htDot-square",
        title: "Error Diffusion · Logo · Error Diffusion · 50",
        description:
          "v3 EC H · mode Halftone · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          htDot: "square",
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "halftone",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-dance-dither-shimmer-crystal",
        title: "Ordered Bayer · Dance GIF · Ordered Bayer · 58",
        description: "v3 EC H · mode Dithered · dither Ordered Bayer · anim Shimmer · Dots modules",
        category: "color-modes",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          bg: "eef2ff",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "atkinson",
          ditherKind: "ordered_bayer",
          ditherStrength: 58,
          dotRot: 0,
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "circle",
          fg: "166534",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-dither-santa",
        title: "Error Diffusion · Santa · Error Diffusion · 50",
        description:
          "v3 EC H · mode Dither · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dither",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-king-poster-wave",
        title: "Error Diffusion · King GIF · Error Diffusion · 50",
        description: "v3 EC H · mode Mosaic · dither Error Diffusion · anim Wave · Diamond modules",
        category: "color-modes",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          bg: "fff5e6",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "bw",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "circle",
          fg: "4c1d95",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "rounded_frame",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "mosaic",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__ditherKind-temporal_blue_noise",
        title: "Temporal Blue Noise · Logo · Temporal Blue Noise · 50",
        description:
          "v3 EC H · mode Dithered · dither Temporal Blue Noise · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "temporal_blue_noise",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__hero-dither-dance-adaptive_threshold",
        title: "Adaptive Threshold · Dance GIF · Adaptive Threshold · 75",
        description: "v3 EC H · mode Dithered · dither Adaptive Threshold · anim Wave · fit Cover",
        category: "color-modes",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "sierra_2",
          ditherKind: "adaptive_threshold",
          ditherStrength: 75,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "blue_noise",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-center-test",
        title: "Error Diffusion · Test · Error Diffusion · 50",
        description:
          "v3 EC H · mode Center · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 2,
          matrix: "bayer4",
          mode: "center",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-dance-dither-wave-etched",
        title: "Screened Blue Noise · Dance GIF · Screened Blue Noise · 62",
        description:
          "v3 EC H · mode Dithered · dither Screened Blue Noise · anim Wave · Connected modules",
        category: "color-modes",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          bg: "f0fdf4",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "sierra_2",
          ditherKind: "screened_blue_noise",
          ditherStrength: 62,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "rounded",
          fg: "1a365d",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "connected",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-extreme-santa",
        title: "Error Diffusion · Santa · Error Diffusion · 50 · Mode Extreme 2",
        description:
          "v3 EC H · mode Extreme · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "extreme",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__ditherKind-anim-adaptive_threshold-king",
        title: "Adaptive Threshold · King GIF · Adaptive Threshold · 70",
        description:
          "v3 EC H · mode Dithered · dither Adaptive Threshold · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "sierra_2",
          ditherKind: "adaptive_threshold",
          ditherStrength: 70,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__ditherStr-25",
        title: "Error Diffusion · Tsunami · Error Diffusion · 25",
        description:
          "v3 EC H · mode Dithered · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 25,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__animStack-dance-dither-wave-morph-sbn",
        title: "Screened Blue Noise · Dance GIF · Screened Blue Noise · 65",
        description: "v3 EC H · mode Dithered · dither Screened Blue Noise · anim Wave · fit Cover",
        category: "color-modes",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          bounce: 1,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "sierra_2",
          ditherKind: "screened_blue_noise",
          ditherStrength: 65,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-brightness-logo",
        title: "Error Diffusion · Logo · Error Diffusion · 50 · Mode Brightness 2",
        description:
          "v3 EC H · mode Brightness · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 1,
          matrix: "bayer4",
          mode: "brightness",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-outline-santa",
        title: "Error Diffusion · Santa · Error Diffusion · 50 · Mode Outline 2",
        description:
          "v3 EC H · mode Outline · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "outline",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__ov-x-anim-dance-dithered-wave",
        title: "Screened Blue Noise · Dance GIF · Screened Blue Noise · 55",
        description: "v4 EC H · mode Dithered · dither Screened Blue Noise · anim Wave · fit Cover",
        category: "color-modes",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "sierra_2",
          ditherKind: "screened_blue_noise",
          ditherStrength: 55,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "blue_noise",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-pixelate-test",
        title: "Error Diffusion · Test · Error Diffusion · 50 · Mode Pixelate 2",
        description:
          "v3 EC H · mode Pixelate · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "pixelate",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-duotone-logo",
        title: "Error Diffusion · Logo · Error Diffusion · 50 · Mode Duotone 2",
        description:
          "v3 EC H · mode Duotone · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "duotone",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__ditherKind-blue_noise_error_diffusion",
        title: "Blue Noise Error Diffusion · Tsunami · Blue Noise Error Diffusion · 50",
        description:
          "v3 EC H · mode Dithered · dither Blue Noise Error Diffusion · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "blue_noise_error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-subpixel-size-santa",
        title: "Error Diffusion · Santa · Error Diffusion · 50 · Mode Subpixel 2",
        description:
          "v3 EC H · mode Subpixel Size · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel-size",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-x-rstyle-blue-noise-rounded",
        title: "Error Diffusion · Test · Error Diffusion · 50 · Mode X 2",
        description:
          "v4 EC H · mode Blue Noise · dither Error Diffusion · Rounded modules · fit Cover",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blue-noise",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "rounded",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__ditherKind-true_dither",
        title: "True Dither · Logo · True Dither · 50",
        description:
          "v3 EC H · mode Dithered · dither True Dither · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "true_dither",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-gapfill-tsunami",
        title: "Error Diffusion · Tsunami · Error Diffusion · 50 · Mode Gapfill 2",
        description:
          "v3 EC H · mode Gapfill · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 7,
          matrix: "bayer4",
          mode: "gapfill",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-x-dk-dithered-ordered_void_cluster",
        title: "Ordered Void Cluster · Logo · Ordered Void Cluster · 50",
        description:
          "v3 EC H · mode Dithered · dither Ordered Void Cluster · fit Cover · preservation Overlay",
        category: "color-modes",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "ordered_void_cluster",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
    ],
  },
  {
    id: "encoding",
    title: "QR Encoding",
    description: "Version, error correction, and mask diversity across generated scenarios.",
    icon: "Settings2",
    items: [
      {
        id: "nooverlay__mega-static",
        title: "Version 7 · EC Q · V7 · Ec Q",
        description: "v7 EC Q · Diamond modules · variant V7 · Ec Q",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "fff5e6",
          border: 2,
          cGuard: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "Q",
          eyeInner: "rounded",
          eyeOuter: "circle",
          fg: "1a365d",
          finder: "rounded",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          jitter: 0,
          minContrast: 4.5,
          modColor: "by_cluster",
          modulePx: 6,
          palette: "1e3a8a,2563eb,059669,d97706,dc2626",
          paletteMode: "radial",
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 7,
          w: 294,
          wmBlend: "overlay",
          wmEn: 1,
          wmKind: "text",
          wmOpacity: 45,
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-brightness-anim-king",
        title: "Version 3 · EC H · V3 · Ec H",
        description:
          "v3 EC H · mode Brightness · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 6,
          matrix: "bayer4",
          mode: "brightness",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__encoding-ver-4-ec-M",
        title: "Version 4 · EC M · V4 · Ec M",
        description: "v4 EC M · Dots modules · variant V4 · Ec M",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "M",
          finder: "circle",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-center-anim-dance",
        title: "Version 3 · EC H · V3 · Ec H · Mode Center 2",
        description:
          "v3 EC H · mode Center · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 1,
          matrix: "bayer4",
          mode: "center",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__encoding-ver-5-ec-Q",
        title: "Version 5 · EC Q · V5 · Ec Q",
        description: "v5 EC Q · Diamond modules · variant V5 · Ec Q",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "Q",
          finder: "rounded",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          timing: "match_module",
          v: 5,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__tempDither-flicker_safe",
        title: "Version 4 · EC H · V4 · Ec H",
        description: "v4 EC H · anim Shimmer · Diamond modules · variant V4 · Ec H",
        category: "encoding",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          colorCycle: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          jitter: 0,
          mask: 7,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-center-anim-king",
        title: "Version 3 · EC H · V3 · Ec H · Mode Center",
        description:
          "v3 EC H · mode Center · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 0,
          matrix: "bayer4",
          mode: "center",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__encoding-ver-3-ec-L",
        title: "Version 3 · EC L · V3 · Ec L",
        description: "v3 EC L · Rounded modules · variant V3 · Ec L",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "L",
          finder: "rounded",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-center-santa",
        title: "Version 3 · EC H · V3 · Ec H · Mode Center · Mode Center 2",
        description:
          "v3 EC H · mode Center · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 3,
          matrix: "bayer4",
          mode: "center",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mode-halftone-anim-king",
        title: "Version 3 · EC H · V3 · Ec H · Mode Halftone 2",
        description:
          "v3 EC H · mode Halftone · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 4,
          matrix: "bayer4",
          mode: "halftone",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__animPattern-shimmer",
        title: "Version 3 · EC H · V3 · Ec H · Animpattern Shimmer 2",
        description: "v3 EC H · anim Shimmer · Connected modules · variant V3 · Ec H",
        category: "encoding",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gapMode: "negative_space",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          jitter: 0,
          mask: 2,
          modulePx: 6,
          radius: 25,
          style: "connected",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-halftone-dithered-logo",
        title: "Version 3 · EC H · V3 · Ec H · Mode Halftone 3",
        description:
          "v3 EC H · mode Halftone Dithered · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 5,
          matrix: "bayer4",
          mode: "halftone-dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mega-anim-dance",
        title: "Version 3 · EC H · V3 · Ec H · Mega Anim 2",
        description:
          "v3 EC H · mode Wave · dither Error Diffusion · anim Shimmer · Diamond modules",
        category: "encoding",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "bw",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          finder: "circle",
          finderDither: 65,
          fit: "contain",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 3,
          w: 294,
          wmBlend: "screen",
          wmEn: 1,
          wmKind: "text",
          wmOpacity: 40,
          wmPos: "bottom-center",
          wmText: "SCAN",
        },
        isAnimated: true,
      },
      {
        id: "overlay__encoding-ver-5-ec-Q",
        title: "Version 5 · EC Q · V5 · Ec Q · Encoding Ver 2",
        description: "v5 EC Q · mode Mosaic · dither Error Diffusion · Dots modules · fit Cover",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "Q",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "mosaic",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          timing: "match_module",
          v: 5,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__mega-anim-king",
        title: "Version 3 · EC H · V3 · Ec H · Mega Anim 3",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Wave · Rounded modules",
        category: "encoding",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSeed: 777,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          bounce: 1,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "rounded",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          style: "rounded",
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmBlend: "overlay",
          wmEn: 1,
          wmKind: "pattern",
          wmOpacity: 45,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__encoding-ver-7-ec-H",
        title: "Version 7 · EC H · V7 · Ec H",
        description: "v7 EC H · Connected modules · variant V7 · Ec H",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "square",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "connected",
          timing: "match_module",
          v: 7,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__tempDither-blue_noise",
        title: "Version 4 · EC H · V4 · Ec H · Tempdither Blue 2",
        description: "v4 EC H · anim Shimmer · Dots modules · variant V4 · Ec H",
        category: "encoding",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          colorCycle: 1,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "circle",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          jitter: 0,
          mask: 6,
          modulePx: 6,
          radius: 25,
          style: "dots",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__encoding-ver-3-ec-M",
        title: "Version 3 · EC M · V3 · Ec M",
        description: "v3 EC M · mode Blend · dither Error Diffusion · Rounded modules · fit Cover",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "M",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__animHero-dance-drift",
        title: "Version 3 · EC H · V3 · Ec H · Animhero Dance 2",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Drift · fit Cover",
        category: "encoding",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__default",
        title: "Version 3 · EC H · V3 · Ec H · Default 2",
        description: "v3 EC H · variant V3 · Ec H",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          mask: 0,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__animHero-dance-pulse",
        title: "Version 3 · EC H · V3 · Ec H · Animhero Dance 3",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Pulse · fit Cover",
        category: "encoding",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__finder-rounded",
        title: "Version 3 · EC H · V3 · Ec H · Finder Rounded",
        description: "v3 EC H · variant V3 · Ec H",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "rounded",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          mask: 5,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__animHero-dance-scanline",
        title: "Version 3 · EC H · V3 · Ec H · Animhero Dance 4",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Scanline · fit Cover",
        category: "encoding",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__frame-rounded_frame",
        title: "Version 3 · EC H · V3 · Ec H · Frame Rounded",
        description: "v3 EC H · variant V3 · Ec H",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frame: "rounded_frame",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          mask: 2,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__animHero-dance-shimmer",
        title: "Version 3 · EC H · V3 · Ec H · Animhero Dance 5",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Shimmer · fit Cover",
        category: "encoding",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__frame-sticker",
        title: "Version 3 · EC H · V3 · Ec H · Frame Sticker",
        description: "v3 EC H · variant V3 · Ec H",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          mask: 3,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__animHero-dance-shimmer-crossfade",
        title: "Version 3 · EC H · V3 · Ec H · Animhero Dance",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Shimmer · fit Cover",
        category: "encoding",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__frame-tag",
        title: "Version 3 · EC H · V3 · Ec H · Frame Tag",
        description: "v3 EC H · variant V3 · Ec H",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          mask: 4,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__animHero-dance-wave",
        title: "Version 3 · EC H · V3 · Ec H · Animhero Dance 6",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Wave · fit Cover",
        category: "encoding",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__gapMode-inset",
        title: "Version 3 · EC H · V3 · Ec H · Gapmode Inset",
        description: "v3 EC H · variant V3 · Ec H",
        category: "encoding",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          mask: 7,
          modulePx: 6,
          radius: 25,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
    ],
  },
  {
    id: "power-combos",
    title: "Power Combos",
    description: "High-impact stacks combining multiple render, animation, and overlay dimensions.",
    icon: "Sparkles",
    items: [
      {
        id: "overlay__animHero-king-scanline",
        title: "Scanline · King GIF · Scanline",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Scanline · fit Cover",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__power-10",
        title: "Combo · No Fixture · Combo · Text",
        description: "v3 EC H · Rounded modules · variant Combo · Text",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmEn: 1,
          wmKind: "text",
          wmPos: "bottom-center",
          wmText: "SCAN ME",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-dance-poster-wave",
        title: "Wave · Dance GIF · Wave · Crossfade",
        description: "v3 EC H · mode Mosaic · dither Error Diffusion · anim Wave · Diamond modules",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          bg: "fff5e6",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "bw",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "circle",
          fg: "4c1d95",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "rounded_frame",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "mosaic",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-x-rstyle-dithered-dots",
        title: "Dithered · Test · Dithered · Dots",
        description: "v4 EC H · mode Dithered · dither Error Diffusion · Dots modules · fit Cover",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-dance-heatmap-shimmer",
        title: "Shimmer · Dance GIF · Shimmer · Morph",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Shimmer · Dots modules",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          bg: "f0fdf4",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "rounded",
          fg: "1a365d",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmBlend: "overlay",
          wmEn: 1,
          wmKind: "pattern",
          wmOpacity: 40,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-dither-logo",
        title: "Dither · Logo · Dither",
        description:
          "v3 EC H · mode Dither · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dither",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-king-cobalt-scanline",
        title: "Scanline · King GIF · Scanline · Tag",
        description:
          "v3 EC H · mode Wave · dither Error Diffusion · anim Scanline · Connected modules",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          bg: "eff6ff",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "circle",
          fg: "1d4ed8",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          style: "connected",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-halftone-tsunami",
        title: "Halftone · Tsunami · Halftone",
        description:
          "v3 EC H · mode Halftone · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 0,
          matrix: "bayer4",
          mode: "halftone",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-king-forest-drift",
        title: "Drift · King GIF · Drift · Crossfade",
        description:
          "v3 EC H · mode Subpixel · dither Error Diffusion · anim Drift · Rounded modules",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 777,
          animSpeed: 100,
          bg: "f0fdf4",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "rounded",
          fg: "14532d",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__wm-pattern",
        title: "Blend · Santa · Blend · Pattern",
        description:
          "v5 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 5,
          w: 294,
          wmEn: 1,
          wmKind: "pattern",
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "nooverlay__visual-target-stack-2",
        title: "Wave · No Fixture · Wave · Shimmer",
        description:
          "v4 EC H · anim Wave · stack Shimmer · Diamond modules · variant Wave · Shimmer",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animPattern2: "shimmer",
          animSpeed: 100,
          animTarget: "result",
          animTarget2: "modules",
          animWaveAxis: "y",
          data: "https://anqr.link",
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          finder: "rounded",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          interp: "crossfade",
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "diamond",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-outline-tsunami",
        title: "Outline · Tsunami · Outline",
        description:
          "v3 EC H · mode Outline · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "outline",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-dance-glass-pulse",
        title: "Pulse · Dance GIF · Pulse · Rounded Frame",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Pulse · Rounded modules",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          bg: "eef2ff",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          bounce: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "bounce",
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "rounded",
          fg: "1e3a8a",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "rounded_frame",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "rounded",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-pixelate-logo",
        title: "Pixelate · Logo · Pixelate",
        description:
          "v3 EC H · mode Pixelate · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "pixelate",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-dance-cobalt-scanline",
        title: "Scanline · Dance GIF · Scanline · Tag",
        description:
          "v3 EC H · mode Wave · dither Error Diffusion · anim Scanline · Connected modules",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          bg: "eff6ff",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "circle",
          fg: "1d4ed8",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          style: "connected",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__wm-x-style-dots-text",
        title: "Combo · No Fixture · Combo · Text · Wm X 2",
        description: "v5 EC H · Dots modules · variant Combo · Text",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "dots",
          timing: "match_module",
          v: 5,
          w: 294,
          wmEn: 1,
          wmKind: "text",
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-king-pop-shimmer",
        title: "Shimmer · King GIF · Shimmer · Crossfade",
        description: "v3 EC H · mode Mosaic · dither Error Diffusion · anim Shimmer · Dots modules",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          bg: "f0fdf4",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "rounded",
          fg: "1a365d",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "mosaic",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__encoding-ver-7-ec-H",
        title: "Dithered · Test · Dithered · Diamond",
        description:
          "v7 EC H · mode Dithered · dither Error Diffusion · Diamond modules · fit Cover",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          timing: "match_module",
          v: 7,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-dance-noir-scanline",
        title: "Scanline · Dance GIF · Scanline · Crossfade",
        description:
          "v3 EC H · mode Subpixel · dither Error Diffusion · anim Scanline · Connected modules",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          bg: "f8fafc",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "circle",
          fg: "0f172a",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          style: "connected",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__visual-static-4",
        title: "Combo · No Fixture · Combo · Pattern",
        description: "v4 EC H · Connected modules · variant Combo · Pattern",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          finder: "square",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "connected",
          timing: "match_module",
          v: 4,
          w: 294,
          wmEn: 1,
          wmKind: "pattern",
          wmOpacity: 45,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-king-aurora-pulse",
        title: "Pulse · King GIF · Pulse · Sticker",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Pulse · Diamond modules",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          bg: "fff5e6",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "circle",
          fg: "4c1d95",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          img: "/king.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__wmOpacity-30",
        title: "Blend · Santa · Blend · Text",
        description:
          "v7 EC H · mode Blend · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 7,
          w: 294,
          wmEn: 1,
          wmKind: "text",
          wmOpacity: 30,
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: false,
      },
      {
        id: "overlay__hero-motion-dance-wave-drift-cycle",
        title: "Drift · Dance GIF · Drift",
        description: "v3 EC H · mode Wave · dither Error Diffusion · anim Drift · fit Cover",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 404,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "nooverlay__wm-x-style-rounded-text",
        title: "Combo · No Fixture · Combo · Text · Wm X 3",
        description: "v5 EC H · Rounded modules · variant Combo · Text",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          data: "https://anqr.link",
          dotRot: 0,
          ec: "H",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          jitter: 0,
          modulePx: 6,
          radius: 25,
          style: "rounded",
          timing: "match_module",
          v: 5,
          w: 294,
          wmEn: 1,
          wmKind: "text",
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-king-heatmap-shimmer",
        title: "Shimmer · King GIF · Shimmer · Morph",
        description: "v3 EC H · mode Blend · dither Error Diffusion · anim Shimmer · Dots modules",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          bg: "f0fdf4",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          eyeInner: "circle",
          eyeOuter: "rounded",
          fg: "1a365d",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "sticker",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "blend",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          timing: "match_module",
          v: 3,
          w: 294,
          wmBlend: "overlay",
          wmEn: 1,
          wmKind: "pattern",
          wmOpacity: 40,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-halftone-logo",
        title: "Halftone · Logo · Halftone",
        description:
          "v3 EC H · mode Halftone · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/logo.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 1,
          matrix: "bayer4",
          mode: "halftone",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__heroFeature-king-noir-scanline",
        title: "Scanline · King GIF · Scanline · Crossfade",
        description:
          "v3 EC H · mode Subpixel · dither Error Diffusion · anim Scanline · Connected modules",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          bg: "f8fafc",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "H",
          eyeInner: "rounded",
          eyeOuter: "circle",
          fg: "0f172a",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "subpixel",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          style: "connected",
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-x-rstyle-dithered-diamond",
        title: "Dithered · Test · Dithered · Diamond · Mode X 2",
        description:
          "v4 EC H · mode Dithered · dither Error Diffusion · Diamond modules · fit Cover",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "dithered",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "overlay__animHero-king-wave-morph",
        title: "Wave · King GIF · Wave · Morph",
        description: "v3 EC H · mode Wave · dither Error Diffusion · anim Wave · fit Cover",
        category: "power-combos",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/king.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "wave",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 3,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "overlay__mode-x-grad-mosaic-conic",
        title: "Mosaic · Tsunami · Mosaic",
        description:
          "v4 EC H · mode Mosaic · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "power-combos",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "H",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "mosaic",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 4,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
    ],
  },
  {
    id: "qr-art",
    title: "QR Art",
    description: "Art-embedded QR outputs across static and animated source artwork fixtures.",
    icon: "Paintbrush",
    items: [
      {
        id: "artwork__art-santa-mega",
        title: "QR Art · Santa · Diamond · Diamond · Static",
        description:
          "v6 EC M · mode Artwork · dither Error Diffusion · Diamond modules · fit Cover",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          bg: "fff5e6",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "M",
          eyeInner: "rounded",
          eyeOuter: "circle",
          fg: "1a365d",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 0,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          timing: "match_module",
          v: 6,
          w: 294,
          wmBlend: "soft-light",
          wmEn: 1,
          wmKind: "text",
          wmOpacity: 50,
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-dance-stack-target-modules-wave-x-result-wave-y",
        title: "QR Art · Dance GIF · Dots · Dots · Wave",
        description: "v6 EC L · mode Artwork · dither Error Diffusion · anim Wave · stack Wave",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animPattern2: "wave",
          animSpeed: 100,
          animTarget: "modules",
          animTarget2: "result",
          animWaveAxis: "x",
          animWaveAxis2: "y",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "L",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 7,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-tsunami-connected-conic",
        title: "QR Art · Tsunami · Connected · Connected · Static",
        description:
          "v7 EC L · mode Artwork · dither Error Diffusion · Connected modules · fit Cover",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "connected",
          timing: "match_module",
          v: 7,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-test-anim-temp-blue-noise",
        title: "QR Art · Test · Rounded · Rounded · Scanline",
        description:
          "v6 EC L · mode Artwork · dither Error Diffusion · anim Scanline · Rounded modules",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          animTarget: "result",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          style: "rounded",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-tsunami-grad-conic",
        title: "QR Art · Tsunami · Square · Square · Static",
        description:
          "v8 EC L · mode Artwork · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 8,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-santa-anim-stack-wave-drift",
        title: "QR Art · Santa · Diamond · Diamond · Wave",
        description: "v6 EC L · mode Artwork · dither Error Diffusion · anim Wave · stack Drift",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animPattern2: "drift",
          animSeed: 1234,
          animSpeed: 100,
          animTarget: "result",
          animTarget2: "result",
          animWaveAxis: "y",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/santa.png",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 0,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-tsunami-anim-temp-flicker-safe",
        title: "QR Art · Tsunami · Dots · Dots · Pulse",
        description: "v7 EC L · mode Artwork · dither Error Diffusion · anim Pulse · Dots modules",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          animTarget: "result",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 7,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-dance-anim-rich-drift",
        title: "QR Art · Dance GIF · Square · Square · Drift",
        description: "v6 EC L · mode Artwork · dither Error Diffusion · anim Drift · fit Cover",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in_out",
          ec: "L",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-tsunami-anim-stack-wave-shimmer",
        title: "QR Art · Tsunami · Connected · Connected · Wave",
        description: "v6 EC L · mode Artwork · dither Error Diffusion · anim Wave · stack Shimmer",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animPattern2: "shimmer",
          animSpeed: 100,
          animTarget: "result",
          animTarget2: "result",
          animWaveAxis: "x",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "connected",
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-test-anim-shimmer-cycle",
        title: "QR Art · Test · Rounded · Rounded · Shimmer",
        description:
          "v6 EC L · mode Artwork · dither Error Diffusion · anim Shimmer · Rounded modules",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSpeed: 100,
          animTarget: "result",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "059669,0,0284c7,1",
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "rounded",
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-santa-encoding-v8-M",
        title: "QR Art · Santa · Rounded · Rounded · Static",
        description:
          "v8 EC M · mode Artwork · dither Error Diffusion · Rounded modules · fit Cover",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "M",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "rounded",
          timing: "match_module",
          v: 8,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-test-ec-M",
        title: "QR Art · Test · Square · Square · Static",
        description:
          "v6 EC M · mode Artwork · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "M",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-tsunami-combo2",
        title: "QR Art · Tsunami · Dots · Dots · Static",
        description: "v7 EC L · mode Artwork · dither Error Diffusion · Dots modules · fit Cover",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          fg: "6b21a8",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          timing: "match_module",
          v: 7,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-tsunami-style-connected",
        title: "QR Art · Tsunami · Connected · Connected · Static · Art Tsunami 2",
        description:
          "v8 EC L · mode Artwork · dither Error Diffusion · Connected modules · fit Cover",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "connected",
          timing: "match_module",
          v: 8,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-test-anim-stack-wave-drift",
        title: "QR Art · Test · Diamond · Diamond · Wave",
        description: "v6 EC L · mode Artwork · dither Error Diffusion · anim Wave · stack Drift",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animPattern2: "drift",
          animSeed: 1234,
          animSpeed: 100,
          animTarget: "result",
          animTarget2: "result",
          animWaveAxis: "y",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/test.png",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-santa-ec-M",
        title: "QR Art · Santa · Square · Square · Static",
        description:
          "v6 EC M · mode Artwork · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "M",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-dance-stack-shimmer-crossfade-temporal",
        title: "QR Art · Dance GIF · Diamond · Diamond · Shimmer",
        description:
          "v6 EC L · mode Artwork · dither Error Diffusion · anim Shimmer · Diamond modules",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "shimmer",
          animSeed: 811,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_out",
          ec: "L",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gapMode: "negative_space",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "conic",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 4,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          style: "diamond",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 6,
          w: 294,
          wmBlend: "overlay",
          wmEn: 1,
          wmKind: "pattern",
          wmOpacity: 42,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-tsunami-combo1",
        title: "QR Art · Tsunami · Rounded · Rounded · Static",
        description:
          "v7 EC L · mode Artwork · dither Error Diffusion · Rounded modules · fit Cover",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "rounded",
          timing: "match_module",
          v: 7,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-dance-stack-scanline-reverse-morph",
        title: "QR Art · Dance GIF · Connected · Connected · Scanline",
        description:
          "v6 EC L · mode Artwork · dither Error Diffusion · anim Scanline · Connected modules",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSeed: 95,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "ease_in",
          ec: "L",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frame: "tag",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "morph",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 5,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          style: "connected",
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-tsunami-style-dots",
        title: "QR Art · Tsunami · Dots · Dots · Static · Art Tsunami 2",
        description: "v8 EC L · mode Artwork · dither Error Diffusion · Dots modules · fit Cover",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          timing: "match_module",
          v: 8,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-dance-stack-drift-bounce-crossfade",
        title: "QR Art · Dance GIF · Rounded · Rounded · Drift",
        description:
          "v6 EC L · mode Artwork · dither Error Diffusion · anim Drift · Rounded modules",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "drift",
          animSeed: 2026,
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          bounce: 1,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          easing: "bounce",
          ec: "L",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "0ea5e9,0,6366f1,1",
          h: 294,
          img: "/dance.gif",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 3,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "rounded",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 6,
          w: 294,
          wmBlend: "soft-light",
          wmEn: 1,
          wmKind: "text",
          wmOpacity: 48,
          wmPos: "bottom-center",
          wmText: "ANQR",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-tsunami-combo3",
        title: "QR Art · Tsunami · Diamond · Diamond · Static",
        description:
          "v7 EC L · mode Artwork · dither Error Diffusion · Diamond modules · fit Cover",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          eyeInner: "circle",
          eyeOuter: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gapMode: "inset",
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          timing: "match_module",
          v: 7,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-santa-anim-temp-flicker-safe",
        title: "QR Art · Santa · Dots · Dots · Pulse",
        description: "v6 EC L · mode Artwork · dither Error Diffusion · anim Pulse · Dots modules",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          animTarget: "result",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 6,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-tsunami-grad-linear",
        title: "QR Art · Tsunami · Square · Square · Static · Art Tsunami",
        description:
          "v8 EC L · mode Artwork · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 8,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-tsunami-anim-stack-wave-drift",
        title: "QR Art · Tsunami · Diamond · Diamond · Wave",
        description: "v6 EC L · mode Artwork · dither Error Diffusion · anim Wave · stack Drift",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "wave",
          animPattern2: "drift",
          animSeed: 1234,
          animSpeed: 100,
          animTarget: "result",
          animTarget2: "result",
          animWaveAxis: "y",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "1a1a2e,0,e94560,1",
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          interp: "crossfade",
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "diamond",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-test-combo4",
        title: "QR Art · Test · Connected · Connected · Static",
        description:
          "v6 EC L · mode Artwork · dither Error Diffusion · Connected modules · fit Cover",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "connected",
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-santa-anim-temp-blue-noise",
        title: "QR Art · Santa · Rounded · Rounded · Scanline",
        description:
          "v6 EC L · mode Artwork · dither Error Diffusion · anim Scanline · Rounded modules",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "scanline",
          animSpeed: 100,
          animTarget: "result",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          img: "/santa.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          mask: 0,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          reverse: 1,
          serpentine: 0,
          style: "rounded",
          tempDither: "blue_noise",
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-tsunami-combo4",
        title: "QR Art · Tsunami · Connected · Connected · Static · Art Tsunami",
        description:
          "v7 EC L · mode Artwork · dither Error Diffusion · Connected modules · fit Cover",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finder: "rounded",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "radial",
          gradAngle: 135,
          gradStops: "dc2626,0,f97316,1",
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "connected",
          timing: "match_module",
          v: 7,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
      {
        id: "artwork__art-test-anim-temp-flicker-safe",
        title: "QR Art · Test · Dots · Dots · Pulse",
        description: "v6 EC L · mode Artwork · dither Error Diffusion · anim Pulse · Dots modules",
        category: "qr-art",
        params: {
          align: "match_finder",
          animPattern: "pulse",
          animSpeed: 100,
          animTarget: "result",
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorCycle: 1,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          finder: "circle",
          finderDither: 65,
          fit: "cover",
          format: "gif",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          grad: "linear",
          gradAngle: 135,
          gradStops: "7c3aed,0,ec4899,0.5,f59e0b,1",
          h: 294,
          img: "/test.png",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          style: "dots",
          tempDither: "flicker_safe",
          timing: "match_module",
          v: 6,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: true,
      },
      {
        id: "artwork__art-tsunami-eye-cc",
        title: "QR Art · Tsunami · Square · Square · Static · Art Tsunami 2",
        description:
          "v7 EC L · mode Artwork · dither Error Diffusion · fit Cover · preservation Overlay",
        category: "qr-art",
        params: {
          align: "match_finder",
          animSpeed: 100,
          blendPres: 0,
          blendPresMode: "overlay",
          bnSeed: 0,
          bnTile: 64,
          colorDither: "none",
          colorMode: "color",
          data: "https://anqr.link",
          diffusionKernel: "floyd_steinberg",
          ditherKind: "error_diffusion",
          ditherStrength: 50,
          dotRot: 0,
          ec: "L",
          eyeInner: "circle",
          eyeOuter: "circle",
          finderDither: 65,
          fit: "cover",
          format: "png",
          frameText: "ANQR",
          gap: 0,
          gifMaxFps: 30,
          gifPal: 256,
          gradAngle: 135,
          h: 294,
          img: "/tsunami.jpg",
          intensity: 50,
          jitter: 0,
          keepAlign: 1,
          keepFinders: 1,
          keepTiming: 1,
          matrix: "bayer4",
          mode: "artwork",
          modulePx: 6,
          protectFmt: 1,
          protectVer: 1,
          radius: 25,
          serpentine: 0,
          timing: "match_module",
          v: 7,
          w: 294,
          wmPos: "bottom-center",
        },
        isAnimated: false,
      },
    ],
  },
] as const;
